import { services } from "../../../../constants";
import { cache } from "../../../persistence/cache";
import { canUpdateToken, updateUserData } from "../tokenOperations";
import { setCookie } from "../../../../utils/cookiesUtils";
import { enhanceUserAddOns } from "../../user/user";

/**
 * Exposes an object containing the method to run the login service with a given config in
 * order to make the final request to the middleware.
 * @public
 */
const login = {
  async run(config) {
    try {
      const response = await this.http.post(`${this.backendHosts.auth}${services.login}`, config);
      const spxToken = response && response.data && response.data.spx;
      const jwtCookie = this.jwtCookie;
      setCookie("spx-token", spxToken, jwtCookie.expirationTime);
      setCookie("UID", Date.now());
      if (canUpdateToken(response)) {
        updateUserData.call(this, response.data.token, response.data.user.globalUserId, config);
      }
      // FIXME This line is not about login, it's about cache, it should not be here
      cache.clear({ database: "layouts" });

      // TODO : Remove deep query from login calls completly from Big screen apps. for billing and addon deep start using new billing details call instead. 
      if(config && !config.exludeDeepQuery){
      const updatedUserAddOns = await enhanceUserAddOns.call(this, response.data.user.settings.addons);
      response.data.user.settings.addons = updatedUserAddOns;
      }

      return response.data.user;
    } catch (error) {
      this.handleErrorResponse(error);
    }
  }
};

export default login;
